const featuresData = [
  {
    icon: "/images/icon/icon_52.svg",
    title: "Smart Ordering",
    subtitle: " QR menu and order",
  },
  {
    icon: "/images/icon/icon_55.svg",
    title: "Booking",
    subtitle: "Automated managing",
  },
  {
    icon: "/images/icon/icon_54.svg",
    title: "Loyalty Card",
    subtitle: "Digital Rewards",
  },
  {
    icon: "/images/icon/icon_53.svg",
    title: "Best Deals",
    subtitle: "AI recommendations",
  },
];

const FeatureBlock = () => {
  return (
    <div
      className="relative z-20 pt-24 pb-24 lg:pt-12 lg:pb-12 overflow-hidden bg-black"
      style={{
        backgroundImage: "url(/images/bg-13.png)",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="max-w-screen-xl mx-auto px-4">
        <div className="flex flex-wrap justify-center gap-y-10">
          {featuresData.map((feature, index) => (
            <div
              key={index}
              className="w-1/2 sm:w-1/2 lg:w-1/4 flex justify-center px-4"
            >
              <div className="flex flex-col items-center text-center max-w-[220px]">
                <div className="w-16 h-16 rounded-full border-2 border-white flex items-center justify-center mb-4 relative bg-black">
                  <img src={feature.icon} alt="icon" className="w-8 h-8" />
                </div>
                <h4 className="text-white text-base font-semibold mb-1">
                  {feature.title}
                </h4>
                <p className="text-sm text-white/70">{feature.subtitle}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Decorative shapes */}
      <img
        src="/images/shape/shape_148.svg"
        alt="shape"
        className="absolute top-0 left-0 w-24 lg:w-32"
      />
      <img
        src="/images/shape/shape_149.svg"
        alt="shape"
        className="absolute bottom-12 left-4 w-8 lg:w-12"
      />
      <img
        src="/images/shape/shape_150.svg"
        alt="shape"
        className="absolute top-12 right-0 w-20 lg:w-32"
      />
      <img
        src="/images/shape/shape_151.svg"
        alt="shape"
        className="absolute bottom-0 right-4 w-10 lg:w-28"
      />
    </div>
  );
};

export default FeatureBlock;
